/* sh-lookbook-carousel (module ACCUEIL-2, 02/10/2026).
   Ordinateur : lois relevées sur la référence (balayage.py, 1440 x 900, pas de 50 px) avec d = rang du look - f,
   f = défilement dans la section / (hauteur - écran) x (looks - 1) :
     largeur = 33 % si d < 0, sinon max(18 %, 33 % - 5 % x d)
     opacité = 1 si d <= 0, sinon paliers (0 : 1 ; 0,6 : 0,6 ; 1,2 : 0,5 ; 1,8 : 0,35 ; 2,4 : 0,3)
     flou    = 0 jusqu'à d = 0,6, puis (2,4 : 3 px ; 3 : 3,5 px), 3,5 px au-delà ; plan = max(1, 4 - arrondi(d))
     colonne des robes : translateY(-défilement) ; piste : part de la course x (largeur de la bande - un look actif),
     loi relevée au repos le 04/10 (l'ancienne table, mesurée en défilement continu, avait 2 à 11 px de retard).
   Tablette et téléphone : Swiper « coverflow » (1,8 vue, centré, échelle 0,82 par rang, sans rotation ni profondeur). */
(function () {
  if (customElements.get('sh-lookbook')) return;

  var OP_D = [0, 0.6, 1.2, 1.8, 2.4], OP_V = [1, 0.6, 0.5, 0.35, 0.3];
  var FL_D = [0, 0.6, 2.4, 3], FL_V = [0, 0, 3, 3.5];

  function interp(x, xs, ys) {
    if (x <= xs[0]) return ys[0];
    for (var i = 1; i < xs.length; i++) {
      if (x <= xs[i]) return ys[i - 1] + (ys[i] - ys[i - 1]) * (x - xs[i - 1]) / (xs[i] - xs[i - 1]);
    }
    return ys[ys.length - 1];
  }

  class ShLookbook extends HTMLElement {
    /* Branchement sûr dans tous les ordres (03/10) : l'élément peut être branché, débranché puis rebranché (rendu de
       sections, déplacement dans la page) ; les écouteurs propres à l'élément ne se posent qu'une fois, ceux de la
       fenêtre et les observateurs sont retirés au débranchement et reposés au branchement ; Swiper absent au moment voulu
       (script chargé avant lui) : nouvel essai au chargement complet de la page. */
    connectedCallback() {
      var self = this;
      if (!this.lie) {
        this.lie = true;
        this.demande = false;
        this.maj = this.maj.bind(this);
        this.planifier = this.planifier.bind(this);
        this.mesurer = this.mesurer.bind(this);
        this.initMobile();
      }
      this.desk = this.querySelector('.sh-lb__desk');
      this.track = this.querySelector('.sh-lb__track');
      this.left = this.querySelector('.sh-lb__left');
      this.products = this.querySelector('.sh-lb__products');
      this.panneau = this.querySelector('.sh-lb__panel');
      this.looks = Array.prototype.slice.call(this.querySelectorAll('.sh-lb__look'));
      this.n = this.looks.length;
      window.addEventListener('scroll', this.planifier, { passive: true });
      window.addEventListener('resize', this.mesurer);
      if (window.ResizeObserver && this.products) {
        this.ro = new ResizeObserver(this.mesurer);
        this.ro.observe(this.products);
      }
      /* Mise en place différée, comme la référence (lookbook_hauteur_390.py, 03/10) : tant que la section est à plus de
         300 px sous l'écran, rien n'est posé (ordinateur : section haute d'un écran, 900 px à 1440 ; téléphone et
         tablette : diapos pleine largeur, 786,19 px à 390, 1 739,19 px à 1024) ; à 300 px, la hauteur de défilement
         (2 423 px à 1440) et le carrousel se posent. Relevé : bascule entre 290 et 302 px sous l'écran aux trois largeurs. */
      if (this.pret) { this.mesurer(); this.creerSwiper(); return; }
      var demarrer = function () {
        if (self.pret || !self.isConnected) return;
        self.pret = true;
        self.mesurer();
        self.creerSwiper();
      };
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entrees) {
          entrees.forEach(function (e) { if (e.isIntersecting) { if (self.io) self.io.disconnect(); demarrer(); } });
        }, { rootMargin: '0px 0px 300px 0px' });
        this.io.observe(this);
      } else {
        demarrer();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.planifier);
      window.removeEventListener('resize', this.mesurer);
      if (this.ro) { this.ro.disconnect(); this.ro = null; }
      if (this.io) { this.io.disconnect(); this.io = null; }
    }

    mesurer() {
      if (!this.pret || !this.desk || !this.products) return;
      if (getComputedStyle(this.desk).display === 'none') { this.desk.style.height = ''; return; }
      this.desk.style.height = this.products.offsetHeight + 'px';
      this.maj();
    }

    /* Mise à jour dans le rappel d'animation qui suit l'événement de défilement (relevé lookbook_phase.py, 04/10) : le
       défilement doux déplace la page dans son propre rappel d'animation, juste avant ; lue à ce moment, la position est
       celle qui va être dessinée, et la colonne des robes n'a aucun retard sur la page (référence : 0,12 px en moyenne
       avant le dessin). Une mise à jour faite dans l'événement lui-même avait une image de retard (5 px en moyenne,
       15 px au plus pour un coup de molette de 600 px). */
    planifier() {
      if (this.demande) return;
      this.demande = true;
      requestAnimationFrame(this.maj);
    }

    maj() {
      this.demande = false;
      if (!this.pret || !this.desk || !this.n || getComputedStyle(this.desk).display === 'none') return;
      var r = this.desk.getBoundingClientRect();
      var vh = window.innerHeight;
      var etendue = Math.max(0, r.height - vh);
      var s = Math.max(0, Math.min(etendue, -r.top));
      this.products.style.transform = 'translate3d(0, ' + (-s).toFixed(2) + 'px, 0)';
      var pas = this.n > 1 ? this.n - 1 : 1;
      var f = etendue > 0 ? s / etendue * pas : 0;
      /* Translation de la piste (loi relevée le 04/10, lookbook_piste.py et lookbook_piste_temps.py, 1440 x 900) :
           tx = part de la course x (largeur de la bande, arrondie au pixel - largeur d'un look actif, arrondie)
         où la largeur de la bande est celle des looks AVANT ce nouvel état (la référence la lit dans la page, puis pose
         les nouvelles largeurs) : en défilement continu l'écart d'un événement est sous 2 px, au repos il est nul.
         Exemples référence : s = 300 -> 220,05 px ; 600 -> 490,90 ; 900 -> 800,75 ; 1 523 -> 1 478,00. */
      var gaucheBande = Infinity, droiteBande = -Infinity;
      for (var j = 0; j < this.n; j++) {
        var bo = this.looks[j].getBoundingClientRect();
        if (bo.left < gaucheBande) gaucheBande = bo.left;
        if (bo.right > droiteBande) droiteBande = bo.right;
      }
      /* Arrondis au pixel comme la mise en page de la référence (boîtes calées à droite de la zone : la moitié descend) :
         à 1600 un look actif de 412,5 px compte pour 412 (relevé lookbook_piste_molette.py, 04/10) ; 360 à 1440, 307 à 1280. */
      var zone = this.left.clientWidth;
      var bande = zone - Math.round(zone - (droiteBande - gaucheBande));
      var actif = zone - Math.round(zone - 0.33 * zone);
      var tx = (etendue > 0 ? s / etendue : 0) * (bande - actif);
      for (var i = 0; i < this.n; i++) {
        var el = this.looks[i];
        var k = parseInt(el.getAttribute('data-index'), 10) || 0;
        var d = k - f;
        var largeur = d < 0 ? 33 : Math.max(18, 33 - 5 * d);
        var op = d <= 0 ? 1 : interp(d, OP_D, OP_V);
        var flou = d <= 0 ? 0 : interp(d, FL_D, FL_V);
        el.style.flex = '0 0 ' + largeur.toFixed(4) + '%';
        el.style.opacity = op.toFixed(4);
        el.style.zIndex = String(Math.max(1, 4 - Math.round(d)));
        var img = el.querySelector('img');
        if (img) img.style.filter = 'blur(' + flou.toFixed(4) + 'px)';
      }
      this.track.style.transform = 'translate3d(' + tx.toFixed(2) + 'px, 0, 0)';
    }

    /* ------------------------------------------------------------ tablette et téléphone */
    creerSwiper() {
      var self = this;
      var el = this.querySelector('.sh-lb__swiper');
      if (!el || this.swiper || el.swiper) { if (el && el.swiper) this.swiper = el.swiper; return; }
      if (!window.Swiper) {
        /* Swiper pas encore là : un seul nouvel essai, au chargement complet de la page */
        if (!this.attente) {
          this.attente = true;
          window.addEventListener('load', function () { self.attente = false; if (self.isConnected) self.creerSwiper(); }, { once: true });
        }
        return;
      }
      try {
        this.swiper = new window.Swiper(el, {
          effect: 'coverflow',
          centeredSlides: true,
          slidesPerView: 1.8,
          spaceBetween: 0,
          speed: 500,
          grabCursor: true,
          coverflowEffect: { rotate: 0, stretch: 0, depth: 0, modifier: 1, scale: 0.82, slideShadows: false },
          on: { slideChange: function (sw) { self.choisir(sw.activeIndex); } }
        });
      } catch (e) {
        this.swiper = null;
      }
    }

    initMobile() {
      var self = this;
      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-sh-lb-open]')) {
          var slide = e.target.closest('.sh-lb__slide');
          if (slide && self.swiper) self.swiper.slideTo(parseInt(slide.getAttribute('data-index'), 10) || 0);
          self.ouvrir(true);
        } else if (e.target.closest('[data-sh-lb-toggle]')) {
          self.ouvrir(!(self.panneau && self.panneau.classList.contains('is-open')));
        }
        var ajout = e.target.closest('[data-sh-lb-add]');
        if (ajout) {
          var S = window.Shestia || {};
          if (S.cart && S.cart.add) {
            S.cart.add([{ id: parseInt(ajout.getAttribute('data-sh-lb-add'), 10), quantity: 1 }]).then(function () {
              if (S.drawers && S.drawers.open) S.drawers.open('cart');
            }).catch(function () {});
          }
        }
      });
    }

    choisir(i) {
      var ps = this.querySelectorAll('.sh-lb__panel-look');
      for (var k = 0; k < ps.length; k++) {
        var actif = parseInt(ps[k].getAttribute('data-index'), 10) === i;
        ps[k].classList.toggle('is-active', actif);
        ps[k].setAttribute('aria-hidden', actif ? 'false' : 'true');
      }
    }

    ouvrir(oui) {
      if (!this.panneau) return;
      this.panneau.classList.toggle('is-open', oui);
      var corps = this.panneau.querySelector('.sh-lb__panel-body');
      if (corps) corps.setAttribute('aria-hidden', oui ? 'false' : 'true');
      this.querySelectorAll('[data-sh-lb-open], [data-sh-lb-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', oui ? 'true' : 'false'); });
    }
  }

  customElements.define('sh-lookbook', ShLookbook);
})();
